import './kidsAge.css';

// Preparation of the view, to update and use if the rollout is decided (not used yet)
export const KidsAgesView = Backbone.View.extend({
  initialize: function (options) {
    this.model = options.model;
    this.viewSelector = options.viewElement;
    this.viewPrefix = typeof options.prefix !== 'undefined' ? options.prefix : '';
    this.triggerPrefix = options.triggerPrefix;
    this.inputChildrenSelector = options.inputChildrenSelector;
    this.inputChildren2Selector = options.inputChildren2Selector;
    this.initKidsAgesValues(this.model);

    this.stopListening(dispatcher, this.viewPrefix + 'kidsAges:render');
    this.listenTo(dispatcher, this.viewPrefix + 'kidsAges:render', this.render);

    this.stopListening(dispatcher, this.viewPrefix + 'kidsAges:setAge');
    this.listenTo(dispatcher, this.viewPrefix + 'kidsAges:setAge', this.setAge);

    this.stopListening(dispatcher, this.viewPrefix + 'kidsAges:setAgesError');
    this.listenTo(dispatcher, this.viewPrefix + 'kidsAges:setAgesError', this.setAgesError);

    this.stopListening(dispatcher, this.viewPrefix + 'kidsAges:initKidsAgesValues');
    this.listenTo(dispatcher, this.viewPrefix + 'kidsAges:initKidsAgesValues', this.initKidsAgesValues);

    this.stopListening(dispatcher, this.viewPrefix + 'kidsAges:handleAgeSelectStatus');
    this.listenTo(dispatcher, this.viewPrefix + 'kidsAges:handleAgeSelectStatus', this.handleAgeSelectStatus);

    this.stopListening(dispatcher, 'kidsAges:calculateHeightBlock');
    this.listenTo(dispatcher, 'kidsAges:calculateHeightBlock', this.calculateHeightBlock);
  },

  initKidsAgesValues: function () {
    this.nbSelectAgeOpened = this.model.get('multiparticipants')[0].ages.length;
    this.nbSelectAge2Opened = this.model.get('multiparticipants')[1].ages.length;
    this.lastMaxMinors = this.model.get('participantsRules').children.max + this.model.get('participantsRules').babies.max;

    if (this.nbSelectAgeOpened > 0) {
      this.render('kids', this.nbSelectAgeOpened);
    }

    if (this.nbSelectAge2Opened > 0) {
      this.render('kids_02', this.nbSelectAge2Opened);
    }
  },

  templateSelectAges(identifier, value = false) {
    //select's template
    const selectedValue = value !== false ? parseInt(value) : false;
    const containerClass = selectedValue !== false ? (selectedValue < 3 ? ' isBaby' : ' isKid') : '';
    const selectClass = identifier === 'kids_02' ?  'js-selectKidAgeMulticottage selectKidAgeMulticottage' : 'js-selectKidAge selectKidAge';
    const divClass = identifier === 'kids_02' ?  'selectKidAgeMulticottage-container js-selectKidAgeMulticottage-container' : 'selectKidAge-container js-selectKidAge-container';

    let optionList = '<option value="" disabled selected hidden> &nbsp;&nbsp;- </option>';

    if (SEARCH_SCRIPTS.IS_FACET_PARTICIPANTS) {
      [].forEach.call(oParticipantsRules.values[0].ages, age => {
        const optionClass = age.value < 3 ? 'js-selectBabieAgeOption' : 'js-selectKidageOption',
          selected = selectedValue === parseInt(age.key) ? ' selected' : '';

        optionList = optionList + `<option class="${optionClass}" value="${age.key}"${selected}>${age.value}</option>`;
      });
    } else {
      const maxChildAge = GLOBAL_SCRIPTS.MARKET_CODE === 'fr' ? 18 : 13;//au cas où la facette capacité soit utilisée sur une SCK

      for (let i = 0; i < maxChildAge; i++) {
        const optionClass = i < 3 ? 'js-selectBabieAgeOption' : 'js-selectKidageOption';
        const selected = selectedValue === i ? ' selected' : '';

        optionList = optionList + `<option class="${optionClass}" value="${i}"${selected}>${i}</option>`;
      }
    }

    return `
      <div class="${divClass}${containerClass}">
        <select class="${selectClass}">
          ${optionList}
        </select>
        <span class="customSelectArrow u-Visible-mobile"></span>
      </div>`;
  },

  //gestion des actions déclenchées par le choix d'un âge
  setAge: function (event) {
    const elm = event.currentTarget;
    const value = DEVICE.isMobile ? parseInt(elm.value) : parseInt(elm.getAttribute('value'));
    const isMulticottage = $(event.currentTarget).closest('.kidsAgesContainerMulticottage').length > 0;
    const container = elm.closest('.js-selectKidAge'+ (isMulticottage ? 'Multicottage' : '') + '-container');

    elm.closest('.js-selectKidAge' + (isMulticottage ? 'Multicottage' : '') + '-container').classList.remove('select-alertError');

    if ($('.selectKidAge-container.select-alertError').length && $('.selectKidAgeMulticottage-container.select-alertError').length) {
      $('.js-selectionNotComplete').removeClass('display-alertError');
    }

    //handling classes to compute fullfilled selectAges
    if (value < 3) {
      container.classList.remove('isKid');
      container.classList.add('isBaby');
    } else {
      container.classList.remove('isBaby');
      container.classList.add('isKid');
    }

    this.handleAgeSelectStatus();
    this.updateKidsAges();
  },

  //enregistrements des informations relatives à l'age des enfants (modèle et searchStore)
  updateKidsAges: function () {
    //mise à jour modele
    const nbAccomodation = this.model.get('accommodationNb'),
      nbAdults = this.model.get('multiparticipants')[0].adults,
      nbSeniors = this.model.get('multiparticipants')[0].seniors,
      nbPets = this.model.get('multiparticipants')[0].pets,
      nbAdults2 = this.model.get('multiparticipants')[1].adults,
      nbSeniors2 = this.model.get('multiparticipants')[1].seniors,
      nbPets2 = this.model.get('multiparticipants')[1].pets;

    let kidsAges = [];
    let kidsAges2 = [];

    $.each($(this.viewSelector + ' .js-selectKidAge'), (_key, item) => {
      if ($(item).val()) {
        const val = parseInt($(item).val());
        kidsAges.push(val);
      }
    });

    $.each($(this.viewSelector + ' .js-selectKidAgeMulticottage'), (_key, item) => {
      if ($(item).val()) {
        const val = parseInt($(item).val());
        kidsAges2.push(val);
      }
    });

    const multiparticipants = [{
      adults: nbAdults,
      seniors: nbSeniors,
      pets: nbPets,
      ages: kidsAges
    }, {
      adults: nbAdults2,
      seniors: nbSeniors2,
      pets: nbPets2,
      ages: kidsAges2
    }];

    const nbParticipants = nbAdults + nbSeniors + kidsAges.length + (nbAccomodation === 2) ? nbAdults2 + nbSeniors2 + kidsAges2.length : 0;
    this.model.set({'multiparticipants': multiparticipants, 'totalParticipants': nbParticipants}, {silent: true});

    $.each(this.model.get('multiparticipants'), (i, item) => {
      if (item.ages.toString() !== (i === 0 ? kidsAges.toString() : kidsAges2.toString()) || this.inputChildrenSelector === '#js-popinParticipants-childrenNumber') {
        //on passe par la fonction updateModel pour mémoriser les ages des enfant, afin de mémoriser simultanément le dernier type de participant modifié
        dispatcher.trigger(this.triggerPrefix + ':updateModel', 'kids', kidsAges);
      }
    });

    if (!$('.selectKidAge-container.select-alertError').length && !$('.selectKidAgeMulticottage-container.select-alertError').length) {
      this.setAgesError(false);
    }

    dispatcher.trigger('facette:participants:updateFieldParticipants', false);
  },

  //gestion des caractères enabled/disabled pour les options des selects ages
  handleAgeSelectStatus: function () {
    /* COMMON */
    const participantsRules = this.model.get('participantsRules'),
      intMaxParticipants = participantsRules.maxParticipants,
      maxChildren = participantsRules.children.max,
      maxBabies = participantsRules.babies.max,
      maxMinors = maxChildren + maxBabies;

    /* COTTAGE 1 */
    const nbGrownUp = this.model.get('multiparticipants')[0].adults + this.model.get('multiparticipants')[0].seniors,
      effectiveMaxMinors = (intMaxParticipants - nbGrownUp) > maxMinors ? maxMinors : intMaxParticipants - nbGrownUp,
      nbChildren = $(this.viewSelector + ' .js-selectKidAge-container.isKid').length,
      nbBabies = $(this.viewSelector + ' .js-selectKidAge-container.isBaby').length,
      effectiveMaxChildren = effectiveMaxMinors - maxBabies,
      nbSelectAge = this.model.get('multiparticipants')[0].ages.length;
    this.nbSelectAgeOpened = this.inputChildrenSelector === '#js-popinParticipants-childrenNumber' ? $(this.viewSelector + ' .kidsAgesContainer .js-selectKidAge').length : nbSelectAge;

    /* COTTAGE 2 */
    const nbGrownUp2 = this.model.get('multiparticipants')[1].adults + this.model.get('multiparticipants')[1].seniors,
      effectiveMaxMinors2 = (intMaxParticipants - nbGrownUp2) > maxMinors ? maxMinors : intMaxParticipants - nbGrownUp2,
      nbChildren2 = $(this.viewSelector + ' .js-selectKidAgeMulticottage-container.isKid').length,
      nbBabies2 = $(this.viewSelector + ' .js-selectKidAgeMulticottage-container.isBaby').length,
      effectiveMaxChildren2 = effectiveMaxMinors2 - maxBabies,
      nbSelectAge2 = this.model.get('multiparticipants')[1].ages.length;
    this.nbSelectAge2Opened = nbSelectAge2;

    //handling option disabled
    const disabledKids = nbChildren >= effectiveMaxChildren,
      disabledKids2 = nbChildren2 >= effectiveMaxChildren2,
      disabledBabies = nbBabies >= maxBabies,
      disabledBabies2 = nbBabies2 >= maxBabies;

    $.each($(this.viewSelector + ' .js-selectKidAge-container:not(.isKid) .js-selectKidageOption'), (i, el) => {
      el.disabled = disabledKids;
      if (disabledKids) {
        $(el).addClass('disabled');
      } else {
        $(el).removeClass('disabled');
      }
    });

    $.each($(this.viewSelector + ' .js-selectKidAgeMulticottage-container:not(.isKid) .js-selectKidageOption'), (i, el) => {
      el.disabled = disabledKids2;
      if (disabledKids2) {
        $(el).addClass('disabled');
      } else {
        $(el).removeClass('disabled');
      }
    });

    $.each($(this.viewSelector + ' .js-selectKidAge-container:not(.isBaby) .js-selectBabieAgeOption,' +  this.viewSelector + ' .js-selectKidAgeMulticottage-container:not(.isBaby) .js-selectBabieAgeOption'), (i, el) => {
      el.disabled = disabledBabies;
      if (disabledBabies) {
        $(el).addClass('disabled');
      } else {
        $(el).removeClass('disabled');
      }
    });

    $.each($(this.viewSelector + ' .js-selectKidAgeMulticottage-container:not(.isBaby) .js-selectBabieAgeOption'), (i, el) => {
      el.disabled = disabledBabies2;
      if (disabledBabies2) {
        $(el).addClass('disabled');
      } else {
        $(el).removeClass('disabled');
      }
    });

    //on vérifie si tous les selects sont bien complétés, si oui, on enlève le message d'erreur qui pourrait avoir été affiché
    if (nbSelectAge !== 0 && nbSelectAge2 !== 0) {
      const nbSelectFullfilled = $(this.viewSelector + ' .js-selectKidAge-container').filter('.isBaby, .isKid').length;
      const nbSelect2Fullfilled = $(this.viewSelector + ' .js-selectKidAgeMulticottage-container').filter('.isBaby, .isKid').length;

      if (nbSelectAge === nbSelectFullfilled && nbSelectAge2 === nbSelect2Fullfilled) {
        this.setAgesError(false);
      }
    }
  },

  // -- Check if there is empty ages select
  isAgedFilled: function () {
    return $(this.viewSelector + ' .js-selectKidAge-container:not(.isBaby):not(.isKid)').length === 0;
  },

  //gestion des messages d'alerte lorsque l'utilisateur atteint le maximum relatif à un sélecteur
  setAgesError: function (hasError) {
    if (hasError) {
      //adjust design
      $.each($(this.viewSelector + ' .js-selectKidAge-container:not(.isBaby):not(.isKid)'), (i, el) => {
        $(el).closest('.js-selectKidAge-container').addClass('select-alertError');
        $(el).closest('.searchForm-quantityBlockLineChildren').find('.js-selectionNotComplete').addClass('display-alertError');
      });

      $.each($(this.viewSelector + ' .js-selectKidAgeMulticottage-container:not(.isBaby):not(.isKid)'), (i, el) => {
        $(el).closest('.js-selectKidAgeMulticottage-container').addClass('select-alertError');
        $(DEVICE.isMobile ? el : '#searchEngine-children').closest('.searchForm-quantityBlockLineChildren').find('.js-selectionNotComplete').addClass('display-alertError');
      });

      $('.searchForm-capacity .searchForm-dataOpener').addClass('opened');
      $('.searchForm-capacityContainer.api_autoClose').css('display', 'block');
      $('.searchForm-capacity').addClass('opened');
      $('body').addClass('searchFocused');
    } else {
      $(this.viewSelector + ' .js-selectionNotComplete').removeClass('display-alertError');
    }
  },

  //rendu de tous les selecteurs d'âges
  render: function (identifier, quantity) {
    /* COMMON */
    const participantsRules = this.model.get('participantsRules'),
      intMaxParticipants = participantsRules.maxParticipants,
      maxMinors = participantsRules.children.max + participantsRules.babies.max;

    /* COTTAGE 1 */
    const nbGrownUp = this.model.get('multiparticipants')[0].adults + this.model.get('multiparticipants')[0].seniors,
      nbChildren = parseInt($(this.inputChildrenSelector).val()),
      effectiveMaxMinors = (intMaxParticipants - nbGrownUp) > maxMinors ? maxMinors : intMaxParticipants - nbGrownUp;
    let nbSelectToRemove = 0,
      minorsNumber = typeof quantity !== 'undefined' && typeof quantity !== 'object' ? quantity : effectiveMaxMinors < this.nbSelectAgeOpened ? effectiveMaxMinors : this.nbSelectAgeOpened;

    /* COTTAGE 2 */
    const nbGrownUp2 = this.model.get('multiparticipants')[1].adults + this.model.get('multiparticipants')[1].seniors,
      nbChildren2 = parseInt($(this.inputChildren2Selector).val()),
      effectiveMaxMinors2 = (intMaxParticipants - nbGrownUp2) > maxMinors ? maxMinors : intMaxParticipants - nbGrownUp2;
    let nbSelect2ToRemove = 0,
      minorsNumber2 = typeof quantity !== 'undefined' && typeof quantity !== 'object' ? quantity : effectiveMaxMinors2 < this.nbSelectAge2Opened ? effectiveMaxMinors2 : this.nbSelectAge2Opened;

    /* ALL COOTAGES */
    const cottagesDatas = [{
      identifier: 'kids' || identifier === 'children',
      agesMemorized: this.model.get('multiparticipants')[0].ages,
      nbChildren: nbChildren,
      $kidsContainer: $(this.viewSelector + ' .kidsAgesContainer'),
      nbSelectToRemove: nbSelectToRemove,
      minorsNumber: minorsNumber
    }, {
      identifier: 'kids_02',
      agesMemorized: this.model.get('multiparticipants')[1].ages,
      nbChildren: nbChildren2,
      $kidsContainer: $(this.viewSelector + ' .kidsAgesContainerMulticottage'),
      nbSelectToRemove: nbSelect2ToRemove,
      minorsNumber: minorsNumber2
    }];

    this.displaySelectAgeCottages(identifier === 'kids' ? cottagesDatas[0] : cottagesDatas[1], {
      participantsRules: participantsRules,
      intMaxParticipants: intMaxParticipants,
      maxMinors: maxMinors
    });

    this.nbSelectAgeOpened = $('#js-searchEngine-childrenNumber').val();
    this.nbSelectAge2Opened = $('#js-searchEngine-childrenNumber_02').val();

    /* DISPLAY LABEL & ERRORS */
    this.displayLabel();

    //instanciation des comportements
    dispatcher.trigger(this.triggerPrefix + ':handleParticipantsDisplay');

    /* HEIGHT FOR MOBILE */
    this.calculateHeightBlock();

    dispatcher.trigger('facette:participants:updateFieldParticipants', true);
  },

  displaySelectAgeCottages: function(cottagesDatas, commonDatas) {
    const {
      maxMinors
    } = commonDatas;
    const {
      identifier,
      agesMemorized,
      nbChildren,
      $kidsContainer,
      minorsNumber
    } = cottagesDatas;
    const isPopinParticipant = typeof event !== 'undefined' ? $(event.currentTarget).hasClass('js-fancybox-popinParticipants') : false;

    let {nbSelectToRemove} = cottagesDatas;

    this.nbSelectAgeOpened = isPopinParticipant ? 0 : this.nbSelectAgeOpened;

    if (minorsNumber < (identifier === 'kids_02' ? this.nbSelectAge2Opened : this.nbSelectAgeOpened)) {
      //suppression des selects en trop
      nbSelectToRemove = (identifier === 'kids_02' ? this.nbSelectAge2Opened : this.nbSelectAgeOpened) - minorsNumber;

      while (nbSelectToRemove > 0) {
        $(this.viewSelector + (identifier === 'kids' ? ' .kidsAgesContainer .js-selectKidAge-container' : ' .kidsAgesContainerMulticottage .js-selectKidAgeMulticottage-container')).last().remove();
        nbSelectToRemove--;
      }

      //mise à jour des données
      if (identifier === 'kids' || identifier === 'children') {
        $(this.inputChildrenSelector).val(minorsNumber);
        this.nbSelectAgeOpened = $(this.viewSelector + ' .kidsAgesContainer .js-selectKidAge').length;
      } else if (identifier === 'kids_02'){
        $(this.inputChildren2Selector).val(minorsNumber);
        this.nbSelectAge2Opened = $(this.viewSelector + ' .kidsAgesContainerMulticottage .js-selectKidAgeMulticottage').length;
      }

      this.updateKidsAges(); //si on enlève un selectAges on doit également mettre à jour la liste des âges
      dispatcher.trigger(this.triggerPrefix + ':updateFieldParticipants');
    } else {
      //on vide les selects concernés
      $kidsContainer.html('');
      if (identifier === 'kids') $('.searchForm-quantityBlockCottage:nth-child(1) .kidsSelectorLabel').remove();
      let ageSelectorHTML = '';

      for (let i = 0; i < minorsNumber; i++) {
        const selectedValue = agesMemorized !== null && agesMemorized.length > i ? agesMemorized[i] : false;
        ageSelectorHTML = ageSelectorHTML + this.templateSelectAges(identifier, selectedValue);
      }

      if (ageSelectorHTML.length || (identifier === 'kids_02' ? this.nbSelectAge2Opened : this.nbSelectAgeOpened) > 0) {
        $kidsContainer.html(ageSelectorHTML.trim());
      }

      if (!DEVICE.isMobile) {
        //creation du custom select
        new Form.CustomSelect(this.viewSelector + (identifier === 'kids' ? ' .kidsAgesContainer .js-selectKidAge' : ' .kidsAgesContainerMulticottage .js-selectKidAgeMulticottage'), {}, this.viewPrefix + 'kidsAges:setAge');
        customScrollbar.init(this.viewSelector + ' .customSelect');
      } else {
        //instanciation du comportement sur le select
        $(this.viewSelector + (identifier === 'kids' ? ' .js-selectKidAge' : ' .js-selectKidAgeMulticottage')).on('change', event => {
          this.setAge(event);
        });
      }

      //gestion du message d'alerte si changement de max enfants
      if (maxMinors !== this.lastMaxMinors) {
        if (nbChildren > maxMinors) {
          $('#searchEngine-children .js-formQuantity-errorMessage2').removeClass('u-Hidden').addClass('display-alertError');
        }
        this.lastMaxMinors = maxMinors;
      }
    }
  },

  displayLabel: function() {
    $('.kidsSelectorLabel').remove();
    const $kidsContainer = $(this.viewSelector + ' .kidsAgesContainer');
    const $kidsContainer2 = $(this.viewSelector + ' .kidsAgesContainerMulticottage');
    let ageSelectorLabel = `<p class="kidsSelectorLabel">${SEARCH_SCRIPTS.WORDING_SEARCH.kids_selector_label}</p>`;

    if (DEVICE.isMobile) {
      if (this.nbSelectAgeOpened > 0) $(ageSelectorLabel).insertBefore($kidsContainer);
      if (this.nbSelectAge2Opened > 0) $(ageSelectorLabel).insertBefore($kidsContainer2);

      if (this.nbSelectAgeOpened === 0 && this.nbSelectAgeMulticottageOpened === 0) {
        $('.searchForm-capacityList').removeClass('searchForm-capacityList--withChildren');
      } else  {
        $('.searchForm-capacityList').addClass('searchForm-capacityList--withChildren');
      }
    } else {
      if (this.nbSelectAgeOpened > 0 || this.nbSelectAge2Opened > 0 ) {
        $(ageSelectorLabel).insertBefore($kidsContainer);
      }
    }

    this.calculateHeightBlock();
  },

  calculateHeightBlock: function () {
    if (!DEVICE.isMobile) {
      $('.searchForm-quantityBlockLineChildren').height('');
      let height = '';

      $.each($('.searchForm-quantityBlockLineChildren'), (i, item) => {
        height = $(item).height() > height ? $(item).height() : height;
      });

      $('.searchForm-quantityBlockLineChildren').height(height);
    }
  }
});